var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-google-map"},[_c('div',{ref:"map",staticClass:"google-map",attrs:{"data-marker-id":_vm.activeCenterMarkerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }